'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024$0024anon$002437 from "./presto.types$-Base64-String$$anon$37.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Base64String$() {
  this.c3v = null;
  this.c3w = false;
  this.c3t = null;
  this.c3u = false;
  this.c3x = null;
  this.c3y = false;
}
export { $c_Lpresto_types$Base64String$ as $c_Lpresto_types$Base64String$ };
$p = $c_Lpresto_types$Base64String$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Base64String$;
/** @constructor */
function $h_Lpresto_types$Base64String$() {
}
export { $h_Lpresto_types$Base64String$ as $h_Lpresto_types$Base64String$ };
$h_Lpresto_types$Base64String$.prototype = $p;
$p.nP = (function() {
  if ((!this.c3w)) {
    this.c3v = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c3w = true;
  }
  return this.c3v;
});
$p.qX = (function() {
  if ((!this.c3u)) {
    this.c3t = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.c3u = true;
  }
  return this.c3t;
});
$p.cIl = (function() {
  if ((!this.c3y)) {
    this.c3x = new $j_presto$002etypes$0024$002dBase64$002dString$0024$0024anon$002437.$c_Lpresto_types$Base64String$$anon$37(this);
    this.c3y = true;
  }
  return this.c3x;
});
var $d_Lpresto_types$Base64String$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Base64String$, "presto.types$Base64String$", ({
  YR: 1,
  D: 1
}));
export { $d_Lpresto_types$Base64String$ as $d_Lpresto_types$Base64String$ };
var $n_Lpresto_types$Base64String$;
function $m_Lpresto_types$Base64String$() {
  if ((!$n_Lpresto_types$Base64String$)) {
    $n_Lpresto_types$Base64String$ = new $c_Lpresto_types$Base64String$();
  }
  return $n_Lpresto_types$Base64String$;
}
export { $m_Lpresto_types$Base64String$ as $m_Lpresto_types$Base64String$ };
//# sourceMappingURL=presto.types$-Base64-String$.js.map
